/**
 * The Home Testing section's own vocabulary, mapped onto the panel-wide design
 * tokens in component/common/designSystem/theme.js — the same split
 * moodTheme.js and selfAssessmentTheme.js use: only domain meaning lives here,
 * palettes belong to the design system.
 */
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * Ordered → at the lab → results in. A journey with a good end, so this runs
 * neutral to green rather than green to red: the last stage is where you want
 * everything to be.
 */
export const STAGE_RAMP = [CHART_COLORS.gray, CHART_COLORS.amber, CHART_COLORS.green];

/**
 * How long the person took to post the kit back. This one IS directional —
 * a kit still out after a fortnight is the actionable case — so it runs green
 * to red.
 */
export const RETURN_RAMP = [
  CHART_COLORS.green,
  CHART_COLORS.teal,
  CHART_COLORS.amber,
  CHART_COLORS.red
];

/**
 * How long the laboratory took. Deliberately NOT the traffic light above: the
 * company cannot influence it, and colouring the partner's turnaround red on a
 * company dashboard invites a complaint nobody here can act on.
 */
export const LAB_RAMP = [
  CHART_COLORS.brandSoft,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];

/** How many kits one person has ordered — sparse to repeat. */
export const VOLUME_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];
